<template>
  <span class="noselect text-dark">&nbsp;*</span>
</template>

<script>
export default {
  name: 'RequiredAttribute'
};
</script>
